import AbilityPreview from './src/main';

/* istanbul ignore next */
AbilityPreview.install = function(Vue) {
  Vue.component(AbilityPreview.name, AbilityPreview);
};

export default AbilityPreview;
